import { render, staticRenderFns } from "./IndividualMatchCard.vue?vue&type=template&id=dea3e31e&scoped=true&lang=pug&"
import script from "./IndividualMatchCard.vue?vue&type=script&lang=js&"
export * from "./IndividualMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./IndividualMatchCard.vue?vue&type=style&index=0&id=dea3e31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea3e31e",
  null
  
)

export default component.exports